import React from 'react'
import ContactHero from '../components/ContactHero'
import MissionValues from '../components/MissionValues'
import Capabilities from '../components/Capabilities'
import ContactCTA from '../components/ContactCTA'
import AboutIndustries from '../components/AboutIndustries'

function AboutUs() {
  return (
    <>
        <ContactHero />

        <MissionValues />

        <Capabilities />

        {/* <ContactCTA /> */}

        {/* <AboutIndustries /> */}
    </>
  )
}

export default AboutUs